import React, { useEffect, useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import '../BigPic/BigPic.scss';
import './BigVideoWrapper.scss';
import { IComponentLiveCut } from '../../component';
import { IPoint } from '../../global';
import useTheme from '../hooks/useTheme';
import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import LiveCut from './LiveCut';
import { IMedium, IMediumOptions} from '../../store/VideoStore';
import RootStore from '../../store/RootStore';
import SwipeableViews from 'react-swipeable-views';
import intl from 'react-intl-universal';
import { isWeb, isWeixinWeb, debounce, isAndroid} from '../../utils/util';
import imageUtil from '../../utils/image';
import Player from '../VideoV2/Player';
import VideoManager from '../VideoV2/Manager';
import { BigPicHeader } from '../BigPic/BigPicMain';
import SearchRow from '../ComponentVote/Search';
import ReactSVG from 'react-svg';
import ListWrapper, { ILoadMoreResult } from '../Common/ListWrapper';
import GoodPendant from '../ComponentPendantV2/GoodButton';

import {
  isInMiniProgram,
  getToMiniProgramDownloadUrl
} from '../../utils/mini_program';
import useVideoCore from '../ComponentLiveShow/useVideoCore';

interface IBigVideoWrapper extends IComponentLiveCut {
  rootStore?: RootStore;
}

const ToMiniProgramBtn = (props: { downloadUrl: string }) => {
  let { downloadUrl } = props;
  if (isInMiniProgram()) {
    const { miniProgram } = window.wx || {};
    return (
      <div
        style={{
          color: '#fff',
          textAlign: 'center',
          fontSize: 12,
          flex: 1
        }}
        onClick={() =>
          miniProgram && miniProgram.navigateTo({ url: '/' + downloadUrl })
        }
      >
        {intl.get('Download')}
      </div>
    );
  }
  return (
    <wx-open-launch-weapp
      id="launch-btn"
      username="gh_e97c78460d68"
      path={downloadUrl}
      style={{ flex: 1 }}
    >
      <script type="text/wxtag-template">
        {/*注意，需要最小宽度，否则容易出现字换行的情况， white-space:nowrap也无法解决*/}
        <div
          style={{
            color: '#fff',
            textAlign: 'center',
            fontSize: 12
          }}
        >
          {intl.get('Download')}
        </div>
      </script>
    </wx-open-launch-weapp>
  );
};

let __offset = {} as IPoint;

export const SimpleBigVideo = (props: {
  list: IMedium[];
  index: number;
  setIndex: (index: number) => void;
  onClose: () => void;
  onStatusChange: (status: string, index: number) => void;
  rootStore?: RootStore;
  mode: string;
  download?: boolean;
  search?: string;
}) => {
  const {
    index,
    list,
    setIndex,
    onClose,
    onStatusChange,
    rootStore,
    mode,
    search
  } = props;
  const { wxuserStore, videoStore } = rootStore!;

  const onSwitching = (ind: number, type: string) => {
    if (type === 'end') {
      // 移动结束
      if (ind === props.list.length - 1) {
        // 已经到底了，最后一张右滑后弹回来了
        // props.rootStore!.uiStore.showToast({
        //   content: intl.get('This is the last one video')
        // });
      }
    }
  };

  const { onCreated, bigVideoWrapper, size } = useVideoCore({
    list,
    index,
    mode
  });

  const onIndexChange = (ind: number) => {
    let keys = VideoManager.keys();
    keys.forEach((key: string) => {
      let instance = VideoManager.getPlayerInstance(key);
      if (instance) {
        instance.pause();
      }
    });

    setIndex(ind);
  };

  const nextClick = () => {
    if (index >= list.length - 1) {
      props.rootStore!.uiStore.showToast({
        content: intl.get('This is the last one video')
      });
      return;
    } else {
      // setIndex(index + 1);
      onIndexChange(index + 1);
    }
  };

  const prepClick = ()=>{
    if(index > 0) {
      onIndexChange(index - 1);
    }
  };

  const shouldShowDownloadBtn = () => {
    if (props.download) {
      return (
        (!window.isweixin &&
          !window.isweixinweb &&
          window.screen.availWidth > 800) ||
        (window.isweixin && !window.isweixinweb)
      );
    }

    return false;
  };

  const shouldShowOperationBtn = () => {
    if (!!search) {
      return true;
    }
    return false;
  };

  const getDownloadUrl = () => {
    let item = list[index];

    let url = getToMiniProgramDownloadUrl(
      [
        {
          id: item.id,
          url: `https://image6${window.__basename}/${item.source}`
        }
      ],
      'video'
    );
    return url;
  };

  const getTitle = ()=>{
    let item = list[index];

    return item.desc;
  };

  const getRemark = ()=>{
    let item = list[index];
    if(item.options) {
      if(typeof item.options == 'string') {
        try {
          let opt = JSON.parse(item.options);
          return opt.remark || '';
        }catch(e) {

        }
      }
    }
    return '';
  };

  const onItemTouchStart = (e:any)=>{
    console.log(e.target.parentNode.className);
    if(e.target && e.target.parentNode && [
      'prism-progress prism-progress-hover',
      'prism-progress-cursor cursor-hover',
      'prism-controlbar'
    ].indexOf(e.target.parentNode.className) >= 0) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
    console.log(`intouch`, e.target.parentNode.className);
    if(e && e.touches && e.touches[0]) {
      __offset = {
        x:e.touches[0].pageX,
        y:e.touches[0].pageY
      };
    }
  };

  const onItemTouchMove = (e:any)=>{
    if(e && e.touches && e.touches[0] && __offset.x) {
      let current = {
        x:e.touches[0].pageX,
        y:e.touches[0].pageY
      };

      let between = __offset.y - current.y;
      let percent = Math.min(0.3, (Math.abs(between) / window.document.body.clientHeight));
      e.currentTarget.style!.transform = `translateY(${-1 * between}px)`;
      if(Math.abs(between) >= 120) {
        onIndexChange(between < 0 ? Math.max(0, index - 1) : Math.min(list.length - 1, index + 1));
        __offset = {} as IPoint;
      }
    }
  };

  const onItemTouchEnd = (e:any)=>{
    if(e && e.currentTarget && e.currentTarget) {
      // @ts-ignore
      e.currentTarget.style!.transform = 'none';
    }
  };

  const [showGuide, setShowGuide] = useState(false);
  useEffect(()=>{
    let item = window.localStorage.getItem('livecut_guide');
    if(!item) {
      setShowGuide(true);
    }
  }, []);

  useEffect(()=>{
    const onMouseScroll = debounce((e:any)=>{
      if(e && e.wheelDeltaY) {
        if(e.wheelDeltaY < 0) {
          nextClick();
        }
        else if(e.wheelDeltaY > 0) {
          prepClick();
        }
      }
    });

    const onKeyUp = (e:any)=>{
      if(e && e.keyCode) {
        if(e.keyCode == 38) {
          prepClick();
        }
        else if(e.keyCode == 40) {
          nextClick();
        }
      }
    };
    if(isWeb() || isWeixinWeb()) {
      window.addEventListener('keyup', onKeyUp, false);
      window.addEventListener('mousewheel', onMouseScroll, false);
    }
    return ()=>{
      window.removeEventListener('keyup', onKeyUp);
      window.removeEventListener('mousewheel', onMouseScroll);
    }
  }, [index]);

  return createPortal(
    <div className={'livecut-big-video big-video-fixed ' + `type-${mode}`}>
      <div className="slider-wrapper big-pic-main">
        <SwipeableViews
          axis="y"
          enableMouseEvents={true}
          index={index}
          onChangeIndex={onIndexChange}
          onSwitching={onSwitching}
          // 如果不设置成hidden，在大图页会出现右侧的滑动条（0.x秒后消失)
          slideStyle={{ overflow: 'hidden' }}
          resistance={true}
          containerStyle={{
            height: '100vh',
            width: '100%',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          {list.map((one, dataIndex) => {
            if (Math.abs(dataIndex - index) < 3) {
              let options = {} as IMediumOptions;
              let selfSize = Object.assign({}, size);
              try {
                options = JSON.parse(one.options) as IMediumOptions;
                if(options && options.width && options.height) {
                  let percent = Number(options.height) / Number(options.width);
                  let width = Math.min(window.document.body.clientWidth, window.document.body.clientWidth);
                  let height = Math.round(width * percent);
                  selfSize.width = width;
                  selfSize.height = height;
                  selfSize.percent = percent;
                }
              }catch(e) {}

              return (
                <div className="livecut-big-video-item" key={one.id}>
                  <div className="video-calc" style={{height:`calc(100vh - 60px)`}}
                    // onTouchStart={onItemTouchStart}
                    // onTouchMove={onItemTouchMove}
                    // onTouchEnd={onItemTouchEnd}
                  >
                    <div style={{width:`100%`, height:`100%`}}>
                      <Player
                        key={one.id}
                        source={one}
                        useSnapShot={true}
                        videoWidth={`${selfSize.width}px`}
                        videoHeight={`${selfSize.height}px`}
                        autoPlay={false}
                        danmuku={false}
                        controlBarVisibility="always"
                        rootStore={rootStore}
                        targetId={`bigvideo_${one.id}`}
                        onCreated={onCreated}
                        componentDownload={shouldShowDownloadBtn()}
                        onRequestFullscreen={(player: any)=>{
                          if(isAndroid()) {
                            if(selfSize.percent) {
                              player.tag.style.width = `${Math.round(selfSize.width / selfSize.percent)}px`;
                              player.tag.style.height = `${selfSize.width}px`;
                            }
                          }
                        }}
                        onCancelFullscreen={(player: any)=>{
                          if(isAndroid()) {
                            player.tag.style.width = `${selfSize.width}px`;
                            player.tag.style.height = `${selfSize.height}px`;
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="bigpic-wrapper" onClick={e => e.stopPropagation()}>
                    <div className="bigpic-bottom">
                      <div className="bigpic-bottom-info">
                        <div className="title">{getTitle()}</div>
                        {getRemark() ? <div className="remark">{getRemark()}</div> : null}
                      </div>
                      <div className="bigpic-bottom-button">
                        <GoodPendant />
                      </div>
                    </div>
                  </div>
                  <div className="bigpic-operation">
                    <ReactSVG
                      className="bigpic-close position-big-video-wrapper"
                      src={require("../../svg/video-close.svg")}
                      style={{ width: 18, height: 18, padding:`15px`}}
                      onClick={() => {
                        onIndexChange(-1);
                        onClose();
                      }}
                    />
                  </div>
                </div>
              );
            } else {
              return <div style={{height:`100vh`}} key={'empty' + dataIndex} />;
            }
          })}
        </SwipeableViews>
        {showGuide ? <div className="livecut-guide-tip" onClick={()=>{
          setShowGuide(false);
          window.localStorage.setItem('livecut_guide', String(1));
        }}>
          <img src={require('../../assets/video_tip.png')} />
        </div> : null}
      </div>
    </div>,
    bigVideoWrapper
  );
};

let currentPage = {

} as {
  [key:string]:number;
};

const getCurrentPage = (cid:string)=>{
  if(!currentPage[cid]) {
    currentPage[cid] = 1;
  }

  return currentPage[cid];
};

const setCurrentPage = (cid:string, target:number)=>{
  if(!currentPage[cid]) {
    currentPage[cid] = 1;
  }

  currentPage[cid] = target;
};

const Index = (props: IBigVideoWrapper) => {
  const { videoStore, wxuserStore, uiStore } = props.rootStore!;
  const { videos, cid} = props;
  const list = videoStore.livecut_list[cid]?.items;
  const [currentIndex, setCurrentIndex] = useState(-1);
  const onPlay = (item: IMedium, index: number) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    if(videos && videos.length) {
      videoStore.getLiveCutList(String(props.cid), videos, window.gallery.id, getCurrentPage(cid));
    }
  }, [videos]);

  const onRefresh = () => {
    return new Promise(resolve => {
      // currentPage = 1;
      setCurrentPage(cid, 1);
      resolve(videoStore.livecut_list.items);
    });
  };

  const onLoadMore = () => {
    return new Promise<ILoadMoreResult>(resolve => {
      // currentPage += 1;
      if(videos && videos.length) {
        setCurrentPage(cid, getCurrentPage(cid)+1);
        videoStore.getLiveCutList(String(props.cid), videos, window.gallery.id, getCurrentPage(cid)).then(res => {
          resolve({
            // @ts-ignore
            nomore: 40 * (getCurrentPage(cid) + 1) > videoStore.livecut_list[cid].total,
            message: ''
          });
        });
      }else {
        resolve({
          nomore:true,
          message: ''
        });
      }
    });
  };

  const [search, setSearch] = useState('');

  const onSearch = (val: string) => {
    if (val == search) {
      return;
    }

    setSearch(val);
    if (val) {
      videoStore.getLiveCutSearch(cid, videos, window.gallery.id, val).then((res: any) => {
        if (res && res.total && res.items) {
          setCurrentIndex(0);
        }
      });
    } else {
      videoStore.getLiveCutList(String(props.cid), videos, window.gallery.id);
    }
  };

  const { h1Color, h2Color, mainColor } = useTheme();

  const onStatusChange = (sts: string, ind: number) => {
    if (wxuserStore.user.is_mock) {
      wxuserStore.auth();
      return;
    }
    let realList = !!search
      ? videoStore.livecut_search[cid]?.items
      : videoStore.livecut_list[cid]?.items;
    let one = realList ? realList[ind] : null;
    if(one) {
      videoStore
        .upLiveShowStatus(window.gallery.id, one.id, sts)
        .then((res: any) => {
          if (res && res.code == 200) {
            uiStore.showToast({
              content: intl.get('Success'),
              time: 2000,
              icon: 'success-no-circle'
            });
          }
        });
    }
  };

  const getSimpleBigVideo = ()=>{
    !!search ? videoStore.livecut_search[cid].items : list
    if(!!search) {
      if(videoStore.livecut_search[cid]) {
        return videoStore.livecut_search[cid].items;
      }
    }

    return list;
  }

  const searchRef = useRef<any>();
  return (
    <div className="bigvideo-wrapper">
      {!!props.search ? (
        <div className="vote">
          <SearchRow
            search={onSearch}
            placeholder="请输入视频标题"
            h1Color={h1Color}
            h2Color={h2Color}
            mainColor={mainColor}
            ref={searchRef}
          />
        </div>
      ) : null}
      <ListWrapper
        onRefresh={onRefresh}
        onLoadMore={onLoadMore}
        isContainer={true}
        scrollerChildrenSelector={'.gallery-home'}
        eventName={'gallery-list'}
      >
        <LiveCut
          {...props}
          onPlayVideo={onPlay}
          inSearch={search}
          currentIndex={currentIndex}
        />
      </ListWrapper>

      {currentIndex >= 0 ? (
        <SimpleBigVideo
          list={getSimpleBigVideo()}
          index={currentIndex}
          setIndex={setCurrentIndex}
          onClose={() => {
            setCurrentIndex(-1);
            // onChangeIndex(-1);

            // if (!!search) {
            //   onSearch('');
            //   if (
            //     !!searchRef &&
            //     !!searchRef.current &&
            //     typeof searchRef.current.clear == 'function'
            //   ) {
            //     searchRef.current.clear();
            //   }
            // }
          }}
          onStatusChange={onStatusChange}
          rootStore={props.rootStore}
          mode={props.mode}
          download={props.download}
          search={search}
        />
      ) : null}
    </div>
  );
};

export default inject('rootStore')(observer(Index));
